import { InternalPage } from "../../../../components/primitives/layout/InternalPage";
import { PageHeader } from "../../../../components/primitives/layout/PageHeader";
import { NewFeedForm } from "./NewFeedForm";
import { ROUTES } from "../../../../route_paths";

/** Where an admin makes a corpus feed. */
export default function NewFeed() {
  return (
    <InternalPage width="full">
      <PageHeader
        breadcrumbs={[
          { label: "Library", to: ROUTES.internal.library.path() },
          { label: "Feeds", to: ROUTES.internal.library.feeds.path() },
        ]}
        title="New feed"
        subtitle="A feed re-runs this query every week and ingests only what's new."
      />
      <NewFeedForm />
    </InternalPage>
  );
}
